/*
--- getAppInit
	--- fromApi	( Api > App )
{											{
	"id": Number,								id: Number,
	"first_name": String,						firstName: String,
	"last_name": String,						lastName: String,
	"picture_url": String,						picture: String,
}											}
*/
const getAppInit = {
  fromApi: ({
    id,
    first_name,
    last_name,
    picture_url,
    features,
    feature_groups,
    otp_required_for_login,
    otp_method,
  }) => ({
    user: {
      id,
      firstName: first_name,
      lastName: last_name,
      picture: picture_url,
      packagesIds: feature_groups || [],
      otp_required_for_login,
      otp_method,
    },
  }),
};

export default {
  getAppInit,
};
